import { Controller } from '@hotwired/stimulus'
import { Dropdown, Popover, Tooltip } from 'bootstrap'

export default class extends Controller {
  static targets = ['layer', 'popover', 'tooltip', 'dropdown']

  connect() {
    this.popover = new Popover(this.popoverTarget, { container: this.element, placement: 'top', trigger: 'manual' })
    this.tooltip = new Tooltip(this.tooltipTarget, { container: this.element, placement: 'top', trigger: 'manual' })
    this.dropdown = new Dropdown(this.dropdownTarget)
    this.update()
  }

  disconnect() {
    this.popover.dispose()
    this.tooltip.dispose()
    this.dropdown.dispose()
  }

  update() {
    const selected = Array.from(this.element.querySelectorAll('[data-z-index-layer]:checked'), input => input.dataset.zIndexLayer)

    this.layerTargets.forEach(layer => { layer.hidden = !selected.includes(layer.dataset.zIndexLayer) })
    this.toggleOverlay(this.popover, selected.includes('popover'))
    this.toggleOverlay(this.tooltip, selected.includes('tooltip'))
    selected.includes('dropdown') ? this.dropdown.show() : this.dropdown.hide()
  }

  toggleOverlay(overlay, visible) {
    visible ? overlay.show() : overlay.hide()
  }
}
